import AbstractRule from './AbstractRule';
import {AnySchema, ArraySchema, NumberSchema} from 'yup';

export default class MinRule extends AbstractRule {
	protected name = 'min';
	protected defaultParameters = [0];

	mutateScheme<S extends AnySchema>(scheme: S): S {
		if (scheme instanceof NumberSchema) {
			return scheme.min(this.getParameters()[0], 'Validator.should_be_greater_than');
		}

		if (scheme instanceof ArraySchema) {
			return scheme.min(this.getParameters()[0], 'Validator.size_should_be_greater_than');
		}

		return scheme;
	}
}
